<style lang="scss">
@import '~scss/_variables';

#loading {
    display: flex;
    flex-flow: column nowrap;
    align-items: stretch;
    justify-content: center;
    width: 100%;
    height: 100%;
    position: absolute;
        top: 0;
        left: 0;
        z-index: 10;

    user-select: none;

    .google-loader {
        width: 80px;
        transform: scale(1);
        transition: transform 0.4s ease;
    }

    .loading-text {
        margin-top: $grid-size / 2;
        position: relative;
        font-family: $font-family-2;
        font-size: 18px;

        p {
            width: 100%;
            margin: 0;
            position: absolute;
                top: 0;
                left: 0;

            text-align: center;
            transition: all 0.5s ease;
        }

        .rotate-enter,
        .rotate-leave-to {
            opacity: 0;
        }

        .rotate-enter {
            transform: perspective(200px) translateY(-18px) rotate3d(1, 0, 0, 75deg);
        }

        .rotate-leave-to {
            transform: perspective(200px) translateY(18px) rotate3d(1, 0, 0, -75deg);
        }
    }

    &.bounce-leave-to {
        transform: scale(1.15);
    }
}
</style>

<template>
    <transition name="bounce">
        <div id="loading">
            <Loader></Loader>
            <div class="loading-text">
                <transition name="rotate">
                    <p :key="text" v-html="text"></p>
                </transition>
            </div>
        </div>
    </transition>
</template>

<script>
import {
    LOADING_TEXTS
} from '@/const';

import Loader from '@/components/entities/Loader';

export default {
    components: { Loader },
    data () {
        return {
            index: null,
            timeout: null
        };
    },
    computed: {
        text () {
            return LOADING_TEXTS[this.index];
        }
    },
    methods: {
        changeIndex () {
            var index = Math.floor(Math.random() * LOADING_TEXTS.length);

            if (this.index === index) {
                index++;

                if (index >= LOADING_TEXTS.length) {
                    index = 0;
                }
            }

            this.index = index;
        },
        loopText () {
            this.changeIndex();

            var wait = 800;
            wait += this.text.length * 20;
            wait += Math.random() * 600;

            this.timeout = setTimeout(() => {
                this.loopText();
            }, wait);
        }
    },
    created () {
        this.loopText();
    },
    beforeDestroy () {
        clearTimeout(this.timeout);
    }
};
</script>
